module.exports = __webpack_public_path__ + "img/logo-dark.a3abdc59.svg";